function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "GasOnline: Los precios de los carburantes online");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M19.872575,0 L37.127425,0 C42.84975,0 45.7102,0 48.790575,0.97375 C52.153575,2.197825 54.802175,4.846425 56.02625,8.209425 C57,11.289325 57,14.150725 57,19.872575 L57,37.127425 C57,42.84975 57,45.7102 56.02625,48.790575 C54.802175,52.153575 52.153575,54.802175 48.790575,56.025775 C45.7102,57 42.84975,57 37.127425,57 L19.872575,57 C14.15025,57 11.289325,57 8.209425,56.025775 C4.846425,54.802175 2.197825,52.153575 0.97375,48.790575 C0,45.7102 0,42.84975 0,37.127425 L0,19.872575 C0,14.150725 0,11.289325 0.97375,8.209425 C2.197825,4.846425 4.846425,2.197825 8.209425,0.97375 C11.289325,0 14.15025,0 19.872575,0 L19.872575,0",
  id: "path-1"
}), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "2.34574298%",
  y1: "97.654257%",
  x2: "100%",
  y2: "0%",
  id: "linearGradient-3"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#362FAF",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6F5AE2",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "99.7608418%",
  id: "linearGradient-4"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFFFFF",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFFFFF",
  stopOpacity: 0.6,
  offset: "100%"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Welcome",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Desktop-HD",
  transform: "translate(-53.000000, -97.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "header",
  transform: "translate(2.000000, 81.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "gasOnline_icono",
  transform: "translate(51.000000, 16.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "Icon-Shape",
  fill: "#D6D6D6",
  xlinkHref: "#path-1"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  mask: "url(#mask-2)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Base",
  fill: "url(#linearGradient-3)",
  x: 0,
  y: 0,
  width: 57,
  height: 57
}), /*#__PURE__*/React.createElement("g", {
  id: "icon",
  transform: "translate(12.825000, 6.650000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(22.107059, 3.364118)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.1641405,34.5484282 C8.72018727,34.6515077 7.30123449,34.1225283 6.25910231,33.0927849 C4.56151679,31.2335552 4.76341314,28.110046 4.97706049,24.8037427 C5.04606803,23.7343845 5.11673175,22.6512823 5.11673175,21.6112714 C5.11673175,12.1252951 1.95035029,12.1252951 0.910584084,12.1252951 C0.445985882,12.1252951 0.0693230045,11.7391716 0.0693230045,11.2629042 C0.0693230045,10.7866368 0.445985882,10.4005133 0.910584084,10.4005133 C6.79925391,10.4005133 6.79925391,18.837909 6.79925391,21.6112714 C6.79925391,22.6891994 6.72859019,23.8086017 6.65627029,24.9175748 C6.46785998,27.8392907 6.28946563,30.6005261 7.48743655,31.913071 C8.21505207,32.5890296 9.18675712,32.9196114 10.1642194,32.8237273 C10.8509036,32.8753075 11.5230764,32.6028544 11.9897252,32.0838191 C13.4686159,30.3228989 12.7855596,25.6367863 12.2858661,22.2149531 C12.0529755,20.8752438 11.9062852,19.5213055 11.8467415,18.1618696 L11.8467415,12.987686 C11.8467415,12.7162839 11.9714283,12.4606468 12.1832617,12.2978218 C13.8270608,11.0456693 13.6974844,10.0557025 13.581394,9.26405238 C13.5515038,9.06993965 13.5340745,8.87404829 13.5292637,8.67767185 C11.5408212,5.04757781 8.08105914,2.51150022 4.0872181,1.75631195 C3.63421316,1.64919018 3.35179487,1.18585821 3.45629201,0.721475228 C3.56086801,0.257092248 4.01276882,-0.0324194942 4.46577376,0.074702276 C11.878761,1.82357634 15.211707,7.43239138 15.211707,8.67767185 C15.2169121,8.79336336 15.2292152,8.9085698 15.248695,9.02264438 C15.590026,10.7062752 14.912096,12.4353419 13.5291848,13.4086543 L13.5291848,18.163729 C13.5929872,19.436174 13.7334471,20.7034447 13.9497759,21.9581034 C14.5268367,25.9250045 15.24696,30.8490487 13.2633283,33.2067786 C12.4819264,34.1121799 11.3421584,34.6056677 10.1641405,34.5484282 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.6878449,13.8516938 C12.4645759,13.852098 12.2502976,13.7615498 12.0922506,13.5998566 C7.39476928,8.78438939 7.96512647,6.26286419 10.4098073,3.75686154 C10.7439616,3.42595633 11.2765421,3.43549623 11.5993396,3.77804335 C11.9142506,4.11226328 11.9142506,4.64205117 11.5993396,4.97627109 C10.1743142,6.43708865 8.82996841,7.81520012 13.2817829,12.3805279 C13.610732,12.7168498 13.6113629,13.2628879 13.2832814,13.6000991 C13.1250767,13.7626816 12.9101675,13.8538766 12.6861887,13.8534737 L12.6878449,13.8516938 Z",
  id: "Shape"
})), /*#__PURE__*/React.createElement("path", {
  d: "M19.2974231,0 C21.6453625,0 23.5488235,1.90714887 23.5488235,4.25973576 L23.5488235,4.25973576 L23.5488235,36.6339033 C23.5488235,37.1044206 23.1681154,37.4858824 22.6985275,37.4858824 L22.6985275,37.4858824 L2.29206073,37.4858824 C1.82247285,37.4858824 1.44176471,37.1044206 1.44176471,36.6339033 L1.44176471,36.6339033 L1.44176471,4.25973576 C1.44176471,1.90714887 3.34514601,0 5.69308538,0 L5.69308538,0 Z M19.4094135,3.25964194 L5.58117477,3.25964194 C5.10385839,3.25964194 4.71688453,3.6504971 4.71688453,4.13278371 L4.71688453,4.13278371 L4.71688453,14.6101575 C4.71688453,15.0923622 5.10385839,15.4832992 5.58117477,15.4832992 L5.58117477,15.4832992 L19.4094135,15.4832992 C19.8867298,15.4832992 20.2737037,15.0923622 20.2737037,14.6101575 L20.2737037,14.6101575 L20.2737037,4.13278371 C20.2737037,3.65057895 19.8867298,3.25964194 19.4094135,3.25964194 L19.4094135,3.25964194 Z",
  id: "Combined-Shape",
  fill: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.66028369,3.36411765 L19.3303045,3.36411765 C19.8021596,3.36411765 20.1847059,3.76374214 20.1847059,4.25666256 L20.1847059,14.9668668 C20.1847059,15.4597873 19.8021596,15.8594118 19.3303045,15.8594118 L5.66028369,15.8594118 C5.1884286,15.8594118 4.80588235,15.4597873 4.80588235,14.9668668 L4.80588235,4.25666256 C4.80588235,3.76365847 5.1884286,3.36411765 5.66028369,3.36411765 Z",
  id: "Shape-Copy",
  fill: "#FFFFFF",
  opacity: 0
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.9239872,36.0441176 L2.54710969,36.0441176 C1.14038877,36.0441176 0,37.1199595 0,38.4470588 L0,40.0489946 C0,40.491361 0.380156121,40.85 0.849063095,40.85 L24.6221134,40.85 C25.0910203,40.85 25.4711765,40.491361 25.4711765,40.0489946 L25.4711765,38.4470588 C25.4711765,37.1199595 24.3307877,36.0441176 22.9239872,36.0441176 Z",
  id: "Shape",
  fill: "url(#linearGradient-4)"
}))))))));

var SvgGasOnlineIcon = function SvgGasOnlineIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "57px",
    height: "57px",
    viewBox: "0 0 57 57",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGasOnlineIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gasOnline-icon.b35a7343.svg";
export { ForwardRef as ReactComponent };